/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".adf-list[_ngcontent-%COMP%]{max-height:150px;overflow:auto}"];
export { styles as styles };
